import { render, staticRenderFns } from "./HelloA.vue?vue&type=template&id=642b00b9&"
var script = {}
import style0 from "./HelloA.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

/* custom blocks */
import block0 from "./HelloA.vue?vue&type=custom&index=0&blockType=meta"
if (typeof block0 === 'function') block0(component)
import block1 from "./HelloA.vue?vue&type=custom&index=1&blockType=example"
if (typeof block1 === 'function') block1(component)

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('HelloA', component.exports)
}
export default component.exports